import { z } from "zod";
import { schemes } from "@zeal/common";
import {
  // EInvoiceTemplateStatus,
  createInvoiceTemplateResponseSchema,
} from "../createInvoiceTemplate/createInvoiceTemplate.schema";

/**
 * Request schema for GET /api/invoices/templates
 * Response schema for GET /api/invoices/templates
 */
export const getInvoiceTemplatesRequestSchema = z.object({
  companyID: schemes.companyID(),
  search: z.string().optional().default(""),
});

// export const invoiceTemplateSummarySchema = z.object({
//   template_id: z.string(),
//   name: z.string(),
//   customer_count: z.number().default(0),
//   customers: z.array(z.string()).default([]),
//   status: z.nativeEnum(EInvoiceTemplateStatus),
//   updated_at: z.string().datetime().optional(),
// });

export const invoiceTemplateSummarySchema =
  createInvoiceTemplateResponseSchema.extend({
    customer_count: z.number().default(0),
    customers: z.array(z.string()).default([]),
    name: z.string(),
  });

export type TGetInvoiceTemplatesRequest = z.infer<
  typeof getInvoiceTemplatesRequestSchema
>;

export const getInvoiceTemplatesResponseSchema = z.object({
  templates: z.array(invoiceTemplateSummarySchema),
});

export type TGetInvoiceTemplatesResponse = z.infer<
  typeof getInvoiceTemplatesResponseSchema
>;
